import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";

const getToken = () => localStorage.getItem("token") || "";

const getError = (error, mensaje) => {
  return {
    ok: false,
    error: error.response?.data || mensaje,
  };
};

// ✅ GET: Traer todos los remitos
export const getRemitos = async (params = {}) => {
  const token = getToken();

  const q = new URLSearchParams(params).toString();
  const url = `${BASE_URL}/remitos${q ? "?" + q : ""}`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });

    return resp.data;
  } catch (error) {
    return getError(error, "Error al obtener remitos");
  }
};

// ✅ GET: Traer un remito por ID
export const getRemitoById = async (id) => {
  const token = getToken();

  const url = `${BASE_URL}/remitos/${id}`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });

    return resp.data;
  } catch (error) {
    return getError(error, "Error al obtener remito");
  }
};

// ✅ POST: Crear nuevo remito
export const postRemito = async (remitoData) => {
  const token = getToken();

  const url = `${BASE_URL}/remitos`;

  try {
    const resp = await axios.post(url, remitoData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });

    return resp.data;
  } catch (error) {
    return getError(error, "Error al crear remito");
  }
};

// ✅ PUT: Actualizar remito
export const putRemito = async (id, remitoData) => {
  const token = getToken();

  const url = `${BASE_URL}/remitos/${id}`;

  try {
    const resp = await axios.put(url, remitoData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });

    return resp.data;
  } catch (error) {
    return getError(error, "Error al actualizar remito");
  }
};

// ✅ DELETE: Desactivar remito / borrado lógico
export const deleteRemito = async (id) => {
  const token = getToken();

  const url = `${BASE_URL}/remitos/${id}`;

  try {
    const resp = await axios.delete(url, {
      headers: { token },
    });

    return resp.data;
  } catch (error) {
    return getError(error, "Error al eliminar remito");
  }
};

// ✅ GET: Remitos pendientes por proveedor
// Para orden de pago de remitos
export const getRemitosPendientesProveedor = async (proveedorId, clienteId = null) => {
  const token = getToken();

  const q = new URLSearchParams();

  if (clienteId) {
    q.set("cliente", clienteId);
  }

  const url = `${BASE_URL}/remitos/pendientes/proveedor/${proveedorId}${
    q.toString() ? "?" + q.toString() : ""
  }`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });

    return resp.data;
  } catch (error) {
    return getError(error, "Error al obtener remitos pendientes del proveedor");
  }
};

// ✅ GET: Remitos pendientes por cliente
// Para orden de cobro de remitos
export const getRemitosPendientesCliente = async (clienteId, proveedorId = null) => {
  const token = getToken();

  const q = new URLSearchParams();

  if (proveedorId) {
    q.set("proveedor", proveedorId);
  }

  const url = `${BASE_URL}/remitos/pendientes/cliente/${clienteId}${
    q.toString() ? "?" + q.toString() : ""
  }`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });

    return resp.data;
  } catch (error) {
    return getError(error, "Error al obtener remitos pendientes del cliente");
  }
};

// ✅ POST: Crear remito de saldo inicial con codrem manual 1..100
export const postRemitoSaldoInicial = async (remitoData) => {
  const nro = Number(remitoData?.codrem);

  if (!Number.isFinite(nro) || nro < 1 || nro > 100) {
    return {
      ok: false,
      error: "El nro de remito manual debe estar entre 1 y 100.",
    };
  }

  const payload = {
    ...remitoData,
    codrem: nro,
    saldoInicial: true,
    observaciones: remitoData?.observaciones || "SALDO INICIAL",
  };

  return await postRemito(payload);
};